//nome = codigo no BD
export const enum EGuidModalComentario {
  'ESCLARECIMENTO_PREVISAO_ORCAMENTARIA' = 'b9434148-b0d6-4361-aa08-35d54465bf2f',
}
